(function() {
  const urlParams = new URLSearchParams(window.location.search);
  if(urlParams.get("filter.v.option.size") === undefined) return;
  const botones = document.getElementById("botonera").children;
  const size = "filter.v.option.size=" + urlParams.get("filter.v.option.size")
  for(item of botones) {
    if(item.href.includes(size)) {
      item.children[0].classList.add("activeWeek");
    }
  }
  
})()